<template>
  <div class="w-full sm:w-1/3 xl:w-1/5">
    <notifications position="top center" ></notifications>

    <a @click="isOpen = !isOpen" href="#" >
      <button type="button" class="w-full mx-auto inline text-center text-sm uppercase mt-3 px-6 py-3 border border-transparent font-medium shadow-sm text-white bg-pink-500 hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-pink-500"><i class="fas fa-plus mr-2"></i> Add Activity</button>
    </a>

      <transition
          enter-class="transition ease-out duration-100 transform"
          enter-active-class="opacity-0"
          enter-to-class="opacity-100"
          leave-class="transition ease-in duration-200 transform"
          leave-active-class="opacity-100"
          leave-to-class="opacity-0"
      >
      <div  v-if="isOpen"  class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle xl:max-w-lg w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <div class="sm:flex sm:items-start">
            <div class="text-center sm:mt-0 sm:text-left w-full">
              <div class="flex justify-between items-center pb-3">
                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                  Add Pledge Drive Activity ({{this.pledgeDrive.activity_type}})
                </h3>
                <div class="modal-close cursor-pointer z-50">
                  <svg @click="isOpen = false" class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                </div>
              </div>

              <div class="my-3">
                <div>
                  <label for="quantity" class="block text-sm font-medium text-gray-700">Quantity</label>
                  <div class="mt-1">
                    <input type="text" v-model="form.quantity" id="quantity" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300" >
                  </div>
                </div>
              </div>

              <div class="my-3">
                <div>
                  <label for="quantity" class="block text-sm font-medium text-gray-700">Where Did Your Activity Take Place?</label>
                  <div class="mt-1">
                    <select id="type"  v-model="form.event_name"  autocomplete="" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300">
                      <option v-for="pledgeDriveEvent in pledgeDriveEvents">{{pledgeDriveEvent}}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="my-3" v-if="form.event_name == `Other`">
                <div>
                  <label for="quantity" class="block text-sm font-medium text-gray-700">Where Did Your Activity Take Place? (Other)</label>
                  <div class="mt-1">
                    <input type="text" v-model="form.event_name_other" id="event_name_other" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300" >
                  </div>
                </div>
              </div>

              <div class="my-3">
                <div>
                  <label for="quantity" class="block text-sm font-medium text-gray-700">Date Achieved</label>
                  <div class="mt-1">
                    <flat-pickr v-model="form.date_received" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300"></flat-pickr>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button @click="createActivity" type="button" class="w-full inline-flex justify-center border border-transparent shadow-sm px-4 py-2 bg-pink-500 text-base font-medium text-white hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-pink-500 sm:ml-3 sm:w-auto sm:text-sm">
              Add
            </button>
            <button @click="isOpen = false" type="button" class="mt-3 w-full inline-flex justify-center border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none  focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm">
              Cancel
            </button>
          </div>
        </div>
      </div>
      </div>

    </transition>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';


export default {
    name: 'AddPledgeActivityButton',
    props: {
      pledgeDrive: null,
      pledgeDriveEvents: null,
    },
  components: {
    flatPickr
  },
    data() {
      return {
        isOpen: false,
        deposit_name: null,
        form: {
          quantity: null,
          event_name: null,
          event_name_other: null,
          date_received: null,
          _token: null,
          pledge_drive_id: this.pledgeDrive.id,
          campaign_id: this.pledgeDrive.campaign_id,
        }
      }
    },
    methods: {
      setOpenToFalse() {
        this.isOpen = false;
      },
      createActivity() {
        if (!this.form.quantity ) {
          this.$notify({
            text: 'Quantity is required',
            type: 'error',
          })
          return
        }
        if (!this.form.event_name ) {
          this.$notify({
            text: 'Activity location is required',
            type: 'error',
          })
          return
        }

        if (this.form.event_name == 'Other' && !this.form.event_name_other) {
          this.$notify({
            text: 'Activity location (Other) is required',
            type: 'error',
          })
          return
        }
        if (!this.form.date_received ) {
          this.$notify({
            text: 'Date Received is required',
            type: 'error',
          })
          return
        }

        let token = document.head.querySelector('meta[name="csrf-token"]');
        this.form._token = token.content;

        axios.post('/campaign/'+this.pledgeDrive.campaign_id+'/pledge-drive/'+this.pledgeDrive.id+'/pledges/store', this.form)
            .then(response => {
              this.$notify({
                text: this.pledgeDrive.activity_type+' has been added.',
                type: 'success',
              })

              window.location.reload();
            })
      },
    },

  }
</script>

<style scoped>

</style>
